import './styles/ManageJobmarketSettings.scss';

import { Add } from '@mui/icons-material';
import { Grid, Paper, Button, Modal } from '@mui/material';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useJobPricesQuery } from 'api/hooks/jobmarket/jobprices';
import { useJobTypesQuery } from 'api/hooks/jobmarket/jobtypes';
import { translations } from 'locales/i18n';
import usePageHeading from 'utils/hooks/usePageHeading';

import JobPrice from './components/JobPrice';
import JobType from './components/JobType';
import PriceDetail from './components/PriceDetail';
import TypeDetail from './components/TypeDetail';

interface Props {}
export function ManageJobmarketSettings(props: Props) {
  const { t } = useTranslation();
  const [typeModalOpen, setTypeModalOpen] = useState(false);
  const [priceModalOpen, setPriceModalOpen] = useState(false);
  const { data: typeData } = useJobTypesQuery();

  const { data: jobPrices } = useJobPricesQuery();

  usePageHeading({
    desktopOnly: true,
    className: 'manage-jobmarket-settings',
    heading: t(translations.pages.manageJobmarketSettings.title())
  });

  return (
    <Grid container>
      <Grid item xs={12} md={9} className="manage-jobmarket-settings__section">
        <Modal
          className="type-detail-modal"
          open={priceModalOpen}
          onClose={(props, reason) => {
            if (reason && reason === 'backdropClick') return;
            setPriceModalOpen(false);
          }}
        >
          <Grid item component={Paper} elevation={5} className="type-detail-modal__body">
            <PriceDetail newPrice closeHandler={() => setPriceModalOpen(false)} />
          </Grid>
        </Modal>
        <Grid
          container
          component={Paper}
          elevation={3}
          className="manage-jobmarket-settings__section__body"
        >
          <Grid container className="manage-jobmarket-settings__section__body__header">
            {t(translations.pages.manageJobmarketSettings.prices())}
          </Grid>
          {jobPrices.map(p => (
            <JobPrice key={p.id} price={p} />
          ))}
        </Grid>
      </Grid>
      <Grid item xs={12} md={3} className="manage-jobmarket-settings__section">
        <Modal
          className="type-detail-modal"
          open={typeModalOpen}
          onClose={(props, reason) => {
            if (reason && reason === 'backdropClick') return;
            setTypeModalOpen(false);
          }}
        >
          <Grid item component={Paper} elevation={5} className="type-detail-modal__body">
            <TypeDetail newType closeHandler={() => setTypeModalOpen(false)} />
          </Grid>
        </Modal>
        <Grid
          container
          component={Paper}
          elevation={3}
          className="manage-jobmarket-settings__section__body"
        >
          <Grid container className="manage-jobmarket-settings__section__body__header">
            {t(translations.pages.manageJobmarketSettings.categories())}
          </Grid>
          {typeData?.map(t => (
            <JobType type={t} key={t.id} />
          ))}
          <Grid container>
            <Button fullWidth variant="outlined" onClick={() => setTypeModalOpen(true)}>
              <Add />
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
